require('angular')
    .module('oly.common')
    .service('LocationService', ['geolocation', '$q', require('./location.service')]);



// WEBPACK FOOTER //
// ./src/olycommon/location/index.js